export const formatPhone = (value: string): string => {
  // Remove tudo que não é dígito
  const numbers = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos
  const limited = numbers.substring(0, 11);
  
  // Aplica a máscara
  if (limited.length <= 10) {
    // (XX) XXXX-XXXX
    return limited.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  } else {
    // (XX) XXXXX-XXXX
    return limited.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
  }
};
